export const formatPorte = value => {
  const normalized = String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[-_]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  const base = normalized.replace(" porte", "");

  if (["pp", "p", "1", "pequeno"].includes(base)) {
    return "Pequeno porte";
  }

  if (["mp", "m", "2", "medio"].includes(base)) {
    return "Médio porte";
  }

  if (["gp", "g", "3", "grande"].includes(base)) {
    return "Grande porte";
  }

  return String(value || "").trim();
};

export const formatAdminPorte = porte => {
  return String(porte || "")
    .split(",")
    .map(formatPorte)
    .filter(Boolean)
    .join(", ");
};

export const isProspectAdmin = admin => Number(admin?.group_id) === 8;

export const formatAdminTransferLabel = admin => {
  const porte = formatAdminPorte(admin?.porte);
  const role = isProspectAdmin(admin) ? " (Prospect)" : "";

  return porte ? `${porte} - ${admin.name}${role}` : `${admin.name}${role}`;
};
